import AbsComponent from '../../components/AbsComponent';

export default class Checkbox extends AbsComponent {
    constructor(_name = '', _store = {}, _actions = {}, _router = {}, _el = '', _watch, _api, _hideOmegaGrade = false) {
        super(_name, _store, _actions, _router, _el);

        this.watchd = _watch;
        this.api = _api;

        this.hideOmegaGrade = _hideOmegaGrade;

        this.setting();

        let watchD = this.watch(this.store.getState, this.watchd, this.isEqual);
        this.store.subscribe(watchD((newVal, oldVal, path) => this.render(newVal, oldVal, path)));
    }

    setting() {
        axios({
            method: 'GET',
            url: `${this.store.getState().config.apiDomain}${this.api}`,
            params: { locale: this.store.getState().config.locale },
        })
            .then((_res) => {
                _res.data.unshift({ id: 'all', name: this.store.getState().config.l10n['common.filter.all'] });

                let template = _res.data
                    .map((it, idx) => {
                        // @see https://nckorea.atlassian.net/browse/URFE-578
                        // 아이템, 변신, 제작 페이지에서만 '유일' 등급 checkbox 표시(마법인형 페이지에서는 미표시)
                        if (this.hideOmegaGrade && it.id === 8) return '';

                        if (this.watchd === 'spelltype' && !it.id) it.id = it.code;

                        return `
                <span class="checkbox">
                    <input type="checkbox" id="${this.watchd}checkbox_${it.id}" name="${this.watchd}checkbox_${it.id}" value="${it.id}">
                    <label for="${this.watchd}checkbox_${it.id}">
                        ${
                            this.watchd === 'card'
                                ? `
                        <span class="cardtype-${it.id}">${it.id === 'all' ? it.name : it.id}</span>
                        `
                                : `
                        ${it.name}
                        `
                        }
                    </label>
                </span>`;
                    })
                    .join('');
                jQuery(this.el).append(template);

                this.addEvents();
                this.render();
            })
            .catch((error, d) => console.log(error, this.name, d))
            .then((d) => {});
    }

    render(_data = {}) {
        let watchData = this.store.getState()[this.watchd];
        let arr = watchData.split(',');
        jQuery(this.el + ` input`).prop('checked', false);

        if (watchData !== '') {
            for (let i = 0; i < arr.length; i++) {
                jQuery(this.el + ` input:checkbox[value='${arr[i]}']`).prop('checked', true);
            }
        } else {
            jQuery(this.el + ` input:checkbox[value='all']`).prop('checked', true);
        }
    }

    addEvents() {
        jQuery(this.el + ' input').on('change', (e) => {
            let dat = [];
            if (e.currentTarget.value === 'all') {
                jQuery(this.el + ` input:checkbox[value='all']`).prop('checked', true);
                dat = '';
            } else {
                jQuery(this.el + ` input:checkbox[value='all']`).prop('checked', false);
                jQuery(this.el + ' input:checked').each((a, b) => dat.push(b.value));
                dat = dat.join(',');
            }
            this.goRouter(dat);
        });
    }

    goRouter(_dat) {
        this.router.goMultiParam({ [this.watchd]: _dat, page: 1 });
    }
} // end of class
